// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"9732fb9e","218":"bdbcf58b","519":"5b42da62","682":"6ead93f3","942":"4cec39b2"}[chunkId] + ".chunk.css";
};